import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ZodError, ZodSchema } from 'zod';
import { CommonService } from '../common.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ZodValidatorService {
  options: { returnErrors?: boolean, translationKey?: string | null } = {};
  constructor(private commonService: CommonService, private translateService: TranslateService) { }

  validate<T>(schema: ZodSchema<T>, data: any, options: { returnErrors?: boolean, translationKey?: string | null } = { returnErrors: false, translationKey: null }): { success: true; data: T } | { success: false } | { success: false; errors: any } {
    this.options = options

    const result = schema.safeParse(data);

    if (!result.success) {
      const errors = this.formatErrors(result.error);

      if (this.options.returnErrors) {
        return { success: false, errors }; // Return the errors if requested
      } else {
        this.displayErrors(errors);
      }

      return { success: false };
    }

    return { success: true, data: result.data };
  }

  private formatErrors(error: any) {
    const customErrorCountMap = new Map<string, number>();

    return error.errors.map((err: any) => {
      const path = err.path.join('.') || 'global'; // Original path for debugging/logging
      const normalizedPath = err.path.map((p: any) => typeof p === 'number' ? '*' : p).join('.');

      let customType = err.params?.type || err.code;
      let i18nkey = this.options.translationKey ? `validation.${this.options.translationKey}.${normalizedPath}.${customType}` : `validation.${normalizedPath}.${customType}`;

      let translated = this.translateService.instant(i18nkey);

      if(translated === i18nkey && customType === 'too_small' && err.code === 'too_small') {
        customType = 'too_short';
        i18nkey = this.options.translationKey ? `validation.${this.options.translationKey}.${normalizedPath}.${customType}` : `validation.${normalizedPath}.${customType}`;
        translated = this.translateService.instant(i18nkey);
      }

      if(translated === i18nkey && customType === 'too_big' && err.code === 'too_big') {
        customType = 'too_long';
        i18nkey = this.options.translationKey ? `validation.${this.options.translationKey}.${normalizedPath}.${customType}` : `validation.${normalizedPath}.${customType}`;
        translated = this.translateService.instant(i18nkey);
      }

      if(translated === i18nkey) {
        console.warn('Missing i18n key', i18nkey)
        translated = err.message;  // Fallback to default error message
      }

      return { path: err.path, message: translated };
    });
  }

  private displayErrors(errors: any) {
    const messageMap = new Map<string, number>();
    console.log('Zod Full Errors List', errors)

    for (const err of errors) {
      const msg = err.message;
      messageMap.set(msg, (messageMap.get(msg) || 0) + 1);
    }

    const groupedMessages = Array.from(messageMap.entries()).map(([msg, count]) => {
      return count > 1 ? `${msg} (x${count})` : msg;
    });

    if(groupedMessages.length)
      this.commonService.showToast(groupedMessages, 'ERROR', { duration: 30 * 1000 }); // display snackbar for 30sec
  }
}
